export class Status {
  id: number;
  nome: string;
  qtd_registros: number;
}



// WEBPACK FOOTER //
// ./src/app/denuncia/status.ts